import { createStore } from '../_core/createStore';
import { errorReportingStore } from './errorReportingStore';

const useErrorReportingStore = createStore({
  creator: errorReportingStore,
  id: 'errorReporting',
  middlewares: {
    devtools: true,
  },
});

export default useErrorReportingStore;
